<template>
  <b-col sm="12">
    <div class="animated fadeIn">
      <b-card class="backClass" style="">
        <div
          slot="header"
          style="display:flex; justify-content: space-between;"
        >
          <HeaderTitle title="FNS Exchange Program"></HeaderTitle>
        </div>
        <div>
          <LoadingCard v-if="loadingData"></LoadingCard>
          <div v-else>
            <b-table
              :fields="fields"
              :items="items"
              size="lg"
              :per-page="perPage"
              :current-page="currentPage"
            >
              <template v-slot:cell(report)="row">
                <b-button
                  size="sm"
                  class="mr-1"
                  @click="downloadReport(row.item.ranum)"
                >
                  <i class="fa fa-download" aria-hidden="true"></i>
                </b-button>
              </template>
            </b-table>
            <div class="mt-5" style="display:flex;justify-content: center; ">
              <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                first-number
                last-number
                size="md"
                pills
              ></b-pagination>
            </div>
          </div>
        </div>
      </b-card>
    </div>
  </b-col>
</template>

<script>
import HeaderTitle from "../../../components/shared/HeaderTitle.vue";
import LoadingCard from "../../../components/shared/LoadingCard.vue";

export default {
  name: "ExchangeReports",
  data: function() {
    return {
      loadingData: false,
      perPage: 10,
      currentPage: 1,
      items: [],
      fields: [
        { key: "ranum", label: "Ranum" },
        { key: "ExchangeDate", label: "Date" },
        { key: "client_company", label: "Customer" },
        { key: "client_location", label: "Location" },
        { key: "FNS_location", label: "FNS Location" },
        { key: "deviceCount", label: "Devices count" },
        { key: "report", label: "Report" }
      ]
    };
  },
  methods: {
    fetchData() {
      this.loadingData = true;
      this.$http.get("api/reports/exchange_reports.php").then(
        res => {
          this.items = res.data;
          this.loadingData = false;
        },
        err => {
          this.loadingData = false;
          console.log(err);
        }
      );
    },
    downloadReport(ranum) {
      this.loadingData = true;
      let params = {};
      params = {};
      this.$http
        .get("api/reports/exchangeReport.php?ranum=" + ranum, {
          params,
          responseType: "blob"
        })
        .then(
          res => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "FNS_EXCHANGE_REPORT.xlsx");
            document.body.appendChild(link);
            link.click();
            this.loadingData = false;
          },
          err => {
            this.loadingData = false;
            console.log(err);
          }
        )
        .then(() => {});
      this.loadingData = false;
    }
  },
  computed: {
    rows() {
      return this.items.length;
    }
  },
  mounted() {
    this.locationsIds = localStorage.getItem("locations");
    this.fetchData();
  },
  components: { HeaderTitle, LoadingCard }
};
</script>
